<div [matMenuTriggerFor]="menu">
  <ng-content></ng-content>
</div>

<mat-menu class="full-width-menu" #menu="matMenu">
  <div class="filter-container" (click)="$event.stopPropagation()">
    <ng-container *ngFor="let filter of filters | keyvalue: originalOrder; let i = index; let last = last">
      <mat-label [translate]="filter.value.label"></mat-label>
      <mat-chip-listbox [multiple]="filter.value.multiple">
        <mat-chip-option
          *ngFor="let option of filter.value.options"
          [value]="option.key"
          [disabled]="filter.value.required ? isDisabled(filter.key, option.key) : false"
          [selected]="isSelected(filter.key, option.key)"
          (selectionChange)="onFilterChange($event, filter.key)"
        >
          <span [translate]="option.label"></span>
        </mat-chip-option>
      </mat-chip-listbox>
      <mat-divider *ngIf="!last"></mat-divider>
    </ng-container>
  </div>
</mat-menu>
